/* THee Store — Shipping threshold bar JS */
(function() {
  var THRESHOLD = 5000; // cents — free shipping over $50

  function renderBar(cartTotal) {
    var bars = document.querySelectorAll('.ts-shipping-bar');
    bars.forEach(function(bar) {
      var fill = bar.querySelector('.ts-shipping-bar__fill');
      var msg  = bar.querySelector('.ts-shipping-bar__msg');
      if (!fill || !msg) return;

      var pct = Math.min(100, Math.round((cartTotal / THRESHOLD) * 100));
      fill.style.width = pct + '%';

      if (cartTotal >= THRESHOLD) {
        bar.classList.add('ts-shipping-bar--achieved');
        msg.innerHTML = '<strong>🎉 You qualify for free shipping!</strong>';
      } else {
        bar.classList.remove('ts-shipping-bar--achieved');
        var remaining = ((THRESHOLD - cartTotal) / 100).toFixed(2);
        msg.innerHTML = 'Add <strong>$' + remaining + '</strong> more for free shipping';
      }
    });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderBar(cart.total_price); })
      .catch(function() {});
  }

  // Initial render
  fetchCart();

  // Re-render on cart changes (works with most cart drawer implementations)
  document.addEventListener('cart:updated', fetchCart);
  document.addEventListener('theme:cart:update', fetchCart);

  // Poll fallback for themes that don't emit events
  var lastTotal = -1;
  setInterval(function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.total_price !== lastTotal) {
          lastTotal = cart.total_price;
          renderBar(cart.total_price);
        }
      })
      .catch(function() {});
  }, 2000);
})();